import { gql } from "@apollo/client";

export const GET_PROCEEDINGS_QUERY = gql`
  query Proceedings($filter: ProceedingsFilterInput) {
    proceedings(filter: $filter) {
      data {
        id
        proceedingId
        location
        status
        description
        reportUpdate        
        partiesNames
        hearingDates {  
          startDate
          endDate
        }   
      }
    }
  }
`;

